module.exports = __webpack_public_path__ + "static/media/charlie-chamero-sm.ea108df2.webm";